const Blazy = require('blazy');

export default function () {

    window.bLazy = new Blazy({
        offset: 500,
        selector: '.lazy',
        loadInvisible: true,
        breakpoints: [
            {
                width: 10, // max-width
                src: 'data-src-xsm',
            },
            {
                width: 640, // max-width
                src: 'data-src-sm',
            },
            {
                width: 768, // max-width
                src: 'data-src-md',
            },
            {
                width: 1024, // max-width
                src: 'data-src-lg',
            },
            {
                width: 1280, // max-width
                src: 'data-src-xl',
            },
        ],
    });


}
